const baseTitle = 'Bioseco - rozwiązania dla ochrony ptaków';

export const pl = {
  "go_up": "do góry",
  page_titles: {
    home: baseTitle,
    products: `Produkty | ${baseTitle}`,
    farm: `Rozwiązanie dla farm wiatrowych | ${baseTitle}`,
    airport: `Rozwiązanie dla lotnisk | ${baseTitle}`,
    area: `Rozwiązanie dla ornitologów | ${baseTitle}`,
    farmPresentation: `Rozwiązanie dla farm wiatrowych | ${baseTitle}`,
    airportPresentation: `Rozwiązanie dla lotnisk | ${baseTitle}`,
    areaPresentation: `Rozwiązanie dla ornitologów | ${baseTitle}`,
    about: `O nas | ${baseTitle}`,
    blog: `Blog | ${baseTitle}`,
    contact: `Kontakt | ${baseTitle}`,
    auctions: `${baseTitle}`,
    projects: `Projekty dofinansowane z UE`,
    awards: `Nagrody | ${baseTitle}`,
    grants: `Granty | ${baseTitle}`,
    certificates: `Certyfikaty | ${baseTitle}`,
    privacy: `Polityka prywatności | ${baseTitle}`,
    bps: `System ochrony ptaków na Farmy Wiatrowe | ${baseTitle}`,
    afms: `System monitorowania fauny dla Portów Lotniczych | ${baseTitle}`,
    bridgealfa: `Bridge Alfa | ${baseTitle}`,
    pmt: `Polskie Mosty Technologiczne USA | ${baseTitle}`,
    eic: `Wsparcie w przygotowaniu Wniosku i SW do EIC Accelerator Pilot | ${baseTitle}`,
    bps2: `Bird Protection System | ${baseTitle}`,
    pbe: `Grant PBE | ${baseTitle}`,
    pbe2: `Grant PBE 2 | ${baseTitle}`,
    ppbb: `Promocja marki produktowej BIOSECO | ${baseTitle}`,
    offshore: `Kompleksowa ochrona ptaków wokół morskich farm wiatrowych | ${baseTitle}`,
    infonews: `Aktualności | ${baseTitle}`
  },
  menu: {
    home: 'Home',
    products: {
      title: 'Produkty',
      farms: 'Farmy wiatrowe',
      airports: "Lotniska",
      ornithologists: "Ornitolodzy"
    },
    certs: 'Certyfikaty',
    awards: 'Nagrody',
    grants: {
      title: 'Granty',
      bps: 'System ochrony ptaków na Farmy Wiatrowe',
      afms: 'System monitorowania fauny dla Portów Lotniczych',
      ba: 'Bridge Alfa',
      pmt: 'Polskie Mosty Technologiczne USA',
      eic: 'Wsparcie w przygotowaniu Wniosku i SW do EIC Accelerator Pilot',
      bps2: 'Bird Protection System',
      pbe: 'Grant PBE',
      pbe2: 'Grant PBE 2',
      ppbb: 'Promocja marki produktowej BIOSECO',
      offshore: 'Kompleksowa ochrona ptaków wokół morskich farm wiatrowych'
    },
    news: 'Aktualności',
    about: 'O nas',
    blog: "Blog",
    contact: "Kontakt",
    ask: "Zadaj pytanie",
    english: "English",
    polish: "Polski",
    deutch: "Deutch",
    project: 'Projekty dofinansowane z UE'
  },
  certs: {
    headingTopText: 'Certyfikaty Bioseco',
    seeCerts: 'Zobacz nasze certyfikaty',
  },
  awards: {
    hedingTopText: 'Nagrody Bioseco',
    seeAwards: 'Zobacz nasze nagrody',
    list: {
      1: "Genewa-Bruksela, 10.2020.<br />Bioseco znalazła się w gronie zwycięzców programu Tech Tour Photonics.",
      2: "Warszawa, 28.09.2020.<br />II Miejsce wśród 50 Najbardziej Kreatywnych Ludzi w Biznesie dla Krzysztofa Paszka, współzałożyciela Bioseco. Nagroda zdobyta na dziesiątej Jubileuszowej Gali pod patronatem Ministerstwa Rozwoju, PKN Orlen SA, Google for Startups, Santander Bank Polska, Krajowa Izba Gospodarcza.",
      3: "Warszawa, 08.2019.<br />Bioseco w gronie dwudziestu firm, które zmienią Polskę według miesięcznika „My Company”.",
      4: "Warszawa, 04.2019.<br />Bioseco startupem pozytywnego wpływu. W pierwszej edycji Raportu Startupów Pozytywnego Wpływu 2019 organizowanego przez Kozminski Business Hub wśród innowacyjnych polskich startupów znalazło się Bioseco.",
      5: "Bruksela, 2019.<br />2018 IEEE N3XT® STAR. Bioseco znalazło się w gronie firm z obszaru innowacyjnych technologii wybranych przez jury IEEE Entrepreneurship Stars, organizacji pod patronatem Parlamentu Europejskiego. Parlament Europejski.",
      6: "Bruksela, 29.11.2018.<br />Wygrana w prestiżowym konkursie EUtop50 dla innowatorów z całej Unii Europejskiej. Dziesiąta edycja konkursu organizowanego przez Parlament Europejski.",
      7: "Gdańsk, 08.04.2015.<br />Pomorskie Sztormy, Zwycięzca konkursu w kategorii Młoda Firma Roku 2014. 10 edycja plebiscytu Gazety Wyborczej i Marszałka Województwa Pomorskiego.",
      8: "Gdynia 12.2014.<br />Lider Pomorskiego Parku Naukowo-Technologicznego w Gdyni. Nagroda przyznana przez społeczność prawie trzystu firm z obszaru nowych technologii.",
      9: "Gdańsk, 24.10.2014. <br/>Nagroda Grand Prix Innowacje 2014. Technikon, 10 Targi Techniki Przemysłowej Nauki i Innowacji.",
    }
  },
  privacy: {
    title: 'Polityka prywatności',
    see: 'Zobacz'
  },
  steps: {
    next: "Następny krok",
    ask: "Zapytaj o więcej",
    watchVideo: "Zobacz video",
    learnMore: "Dowiedz się więcej o produkcie"
  },
  footer: {
    copy: "Copyright <strong>Bioseco</strong>",
    about: "O nas",
    contact: "Kontakt",
    privacy: "Polityka Prywatności",
    auctions: "Przetargi",
    created: "Created in"
  },
  moreAboutUs: "Dowiedz się więcej o nas",
  home: {
    headingTopText: "Witaj w Bioseco",
    headingSubText: "Wprowadzamy rozwiązania dla ochrony ptaków",
    headingBottomText: "Gdzie chciałbyś użyć naszych produktów?",
    farms: "Farmy wiatrowe",
    airports: "Lotniska",
    area: "Teren"
  },
  products: {
    headingTopText: 'Nasze produkty',
    headingBottomText: 'Wybierz miejsce w którym potrzebujesz chronić ptaki:',
    farms: "Farmy wiatrowe",
    airports: "Lotniska",
    area: "Teren"
  },
  team: [
    {
      name: "Adam Jaworski",
      role: "CEO/Prezes Zarządu",
      img: "adam_jaworski.jpg"
    },
    {
      name: "Agnieszka Preś",
      role: "Dyrektor ds. finansowych i administracyjnych",
      img: "agnieszka_pres.jpg"
    },
    {
      name: "Dawid Gradolewski",
      role: "CTO/Członek Zarządu",
      img: "dawid_gradolewski.jpg"
    },
    {
      name: "Damian Dziak",
      role: "Szef działu software",
      img: "damian_dziak.jpg"
    },
    {
      name: "Damian Kaniecki",
      role: "Szef działu hardware",
      img: "damian_kaniecki.jpg"
    },
    {
      name: "Magda Bielawska",
      role: "Commercial Manager",
      img: "magda_bielawska.jpg"
    },
    {
      name: "Włodek Kulesza",
      role: "Szef działu R&D",
      img: "wlodek_kulesza.jpg"
    },
    {
      name: "Małgorzata Alboszta",
      role: "Menedżer HR",
      img: "malgorzata_alboszta.jpg"
    },
    {
      name: "Ewelina Lachowicz",
      role: "Menedżer Operacyjny",
      img: "ewelina_lachowicz.jpg"
    },
    {
      name: "Izabela Szulc",
      role: "Menedżer ds. ISO i projektów unijnych",
      img: "izabela_szulc.jpg"
    },
    {
      name: "Maria Giełdon",
      role: "Specjalista ds. komercyjnych",
      img: "maria_gieldon.jpg"
    },
    {
      name: "Marcel Pańka",
      role: "Junior Business Developer",
      img: "marcel_panka.jpg"
    },
    {
      name: "Tomasz Jasiński",
      role: "Kierownik produkcji",
      img: "tomasz_jasinski.jpg"
    },
    {
      name: "Tomasz Spaleniak",
      role: "Specjalista ds. Logistyki",
      img: "tomasz_spaleniak.jpg"
    },
    {
      name: "Dominik Ambroziak",
      role: "Inżynier Elektroniki / Specjalista BHP",
      img: "dominik_ambroziak.jpg"
    },
    {
      name: "Krzysztof Zakrzewski",
      role: "Lider Zespołu Montażowego / Brygadzista",
      img: "krzysztof_zakrzewski.jpg"
    },
    {
      name: "Bartłomiej Lademan",
      role: "Monter Elektroniki",
      img: "bartlomiej_lademan.jpg"
    },
    {
      name: "Maciej Grzesikiewicz",
      role: "Monter Elektroniki",
      img: "maciej_grzesikiewicz.jpg"
    },
    {
      name: "Arkadiusz Kowalczyk",
      role: "Monter Elektroniki",
      img: "arkadiusz_kowalczyk.jpg"
    },
    {
      name: "Krzysztof Działecki",
      role: "Monter Elektroniki",
      img: "krzysztof_dzialecki.jpg"
    },
    {
      name: "Jakub Pawluk",
      role: "Monter Elektroniki",
      img: "jakub_pawluk.jpg"
    },
    {
      name: "Adam Okun",
      role: "Brygadzista produkcji",
      img: "adam_okun.jpg"
    },
    {
      name: "Arkadiusz Chojka",
      role: "Monter elektroniki",
      img: "arkadiusz_chojka.jpg"
    },
    {
      name: "Paweł Hrynkiewicz - Moczulski",
      role: "Inżynier Elektroniki",
      img: "pawel_hrynkiewicz-moczulski.jpg"
    },
    {
      name: "Krzysztof Domozych",
      role: "Analityk danych",
      img: "krzysztof_domozych.jpg"
    },
    {
      name: "Konrad Szwejk",
      role: "Linux Administrator",
      img: "konrad_szwejk.jpg"
    },
    {
      name: "Przemysław Sadkowski",
      role: "Kierownik ds. technicznej obsługi klienta",
      img: "przemyslaw_sadkowski.jpg"
    },
    {
      name: "Grzegorz Madejski",
      role: "Kierownik ds. Innowacji",
      img: "grzegorz_madejski.jpg"
    },
    {
      name: "Włodzimierz Kaoka",
      role: "Kierownik ds. rozwoju i wdrożenia oprogramowania",
      img: "wlodzimierz_kaoka.jpg"
    },
    {
      name: "Szymon Witkowski",
      role: "Kierownik ds. Utrzymania Oprogramowania",
      img: "szymon_witkowski.jpg"
    },
    {
      name: "Łukasz Wittbrodt",
      role: "Kierownik ds. Aplikacji i Infrastruktury",
      img: "lukasz_wittbrodt.jpg"
    },
    {
      name: "Marcin Detlaf",
      role: "Front-end Developer",
      img: "marcin_detlaf.jpg"
    },
    {
      name: "Ilona Konop",
      role: "analityk danych",
      img: "ilona_konop.jpg"
    },
    {
      name: "Jakub Swenda",
      role: "Młodszy analityk danych",
      img: "jakub_swenda.jpg"
    },
    {
      name: "Sebastian Zbytniewski",
      role: "Młodszy analityk danych B+R",
      img: "sebastian_zbytniewski.jpg"
    },
    {
      name: "Aleksy Stocki",
      role: "Młodszy analityk danych B+R",
      img: "aleksy_stocki.jpg"
    },
  ],
  about: {
    hedingTopText: '<strong>Rozwiązania</strong><br />dla ochrony ptaków',
    hedingSubText: '',
    headingText: 'Spółka Bioseco została utworzona w kwietniu <strong>2013 r.</strong> przez grupę specjalistów w dziedzinie optoelektroniki, radiolokacji i IT w celu opracowania systemu monitorującego i chroniącego ptaki.',
    headSectionTopText: 'Dlaczego nasze<br /><strong>rozwiązanie?</strong><div class="line"></div>',
    headSectionText: 'Firma współpracuje ściśle z ornitologami, chiropterologami i operatorami farm wiatrowych. Przez lata Bioseco udoskonaliło i zoptymalizowało innowacyjny i opłacalny system chroniący ptaki przed kolizjami z turbinami wiatrowymi.',
    ourCertsTitle: 'Nasze<br /> <strong>certyfikaty</strong>',
    ourTeamTitle: 'Nasz<br /><strong>zespół</strong><div class="line"></div>',
    ourTeamText: 'Zespół Bioseco składa się z inżynierów IT, ornitologów, chiropterologów i innych specjalistów skupionych na badaniu awifauny. Współpracujemy z instytucjami takimi jak: Instytut Morski w Gdańsku, Pomorski Park Naukowo-Technologiczny w Gdyni, Technopark Gliwice oraz z organizacjami ornitologicznymi. Celem Bioseco jest tworzenie urządzeń i narzędzi do miarodajnego badania przyrody, które mogą mieć szerokie praktyczne zastosowanie.',
    ourClientsTitle: 'Nasi klienci',
    personOne: 'Adam Jaworski',
    personOneRole: 'CEO',
    personTwo: 'Dawid Gradolewski',
    personTwoRole: 'CTO',
    personThree: 'Małgorzata Alboszta',
    personThreeRole: 'Analityk',
    personFour: 'Damian Kaniecki',
    personFourRole: 'Projektant',
    personFive: 'Paweł Hrynkiewicz',
    personFiveRole: 'Konstruktor',
    personSixRole: 'Elektronik',
    personSeven: 'Damian Dziak',
    personSevenRole: 'Programista',
    personEight: 'Szymon Witkowski',
    personEightRole: 'Programista',
    personNine: 'Krzysztof Domozych',
    personNineRole: 'Konstruktor',
  },
  farmsProducts: {
    headerTopText: '<strong>Rozwiązanie</strong><br />dla farm wiatrowych',
    headerTopSubText: '',
    headerTopTextPresentation: 'Rozwiązanie dla farm wiatrowych',
    headerTopSubTextPresentation: 'Zobacz, jak działa nasz innowacyjny system Bioseco BIRD PROTECTION SYSTEM (BPS)',
    headerText: 'Corocznie dochodzi do wielu kolizji ptaków i nietoperzy z łopatami turbin wiatrowych. Aby znacznie ograniczyć liczbę wypadków, Bioseco stworzyło system ochrony ptaków.',
    whyOurSolutionText: '',
    whyOurSolution: 'Dlaczego nasze rozwiązanie?',
    sectionOneTitle: 'Główne założenie',
    sectionOneText1: 'System urządzeń i oprogramowania zainstalowanego na turbinach',
    sectionOneText2: 'Oszacowanie ilości przelatujących ptaków, rozmiarów i kierunku lotu',
    sectionOneText3: 'Wyzwolenie akcji: ostrzeżenie ptaków i/lub zatrzymanie turbiny',
    sectionOneText4: 'Stworzenie “tarczy bezpieczeństwa”',
    sectionOneText5: 'Zbieranie danych, archiwizowanie w celu generowania statytyk',
    sectionTwoTitle: 'Korzyści',
    sectionTwoText1: '<strong class="bolded">Ochrona ptaków przed zderzeniami z łopatami turbin wiatrowych</strong>',
    sectionTwoText2: 'Korzyści dodatkowe',
    sectionTwoText3: 'Uniknięcie przesiedlenia lęgowisk oraz prowadzenie dodatkowych badań',
    sectionTwoText4: 'Zbieranie cennych danych pod badania przyrodnicze',
    sectionThreeTitle: 'Technologia',
    sectionThreeText1: 'Bezinwazyjny montaż (wykorzystanie istniejącej infrastruktury)',
    sectionThreeText2: 'Objęcie systemem całej farmy',
    sectionThreeText3: 'Schemat działania: detektory na turbinach przekazują dane do jednostki centralnej, gdzie dokonywana jest analiza i wybór odpowiedniej czynności (ostrzeżenie/spowolnienie pracy turbiny/zatrzymanie), achiwizacja danych i przekazanie ich online do użytkownika.',
    sectionThreeText4: 'Elastyczność zastosowania - dopasowanie się do potrzeb użytkownika oraz specyfiki farmy',
    whyIShouldUseThis: 'Dlaczego powinno się tego używać?',
    whyIShouldUseThisOneTopBefore: '',
    whyIShouldUseThisOneTop: '314,000',
    whyIShouldUseThisOneTopAfter: '',
    whyIShouldUseThisOneText: 'liczba aktywnych turbin wiatrowych na całym świecie',
    whyIShouldUseThisTwoTopBefore: '$',
    whyIShouldUseThisTwoTop: '109',
    whyIShouldUseThisTwoTopAfter: 'mld',
    whyIShouldUseThisTwoText: 'kwota zainwestowana w energetykę wiatrową na całym świecie',
    whyIShouldUseThisThreeTopBefore: '',
    whyIShouldUseThisThreeTop: '5',
    whyIShouldUseThisThreeTopAfter: 'mln',
    whyIShouldUseThisThreeText: 'ptaków i nietoperzy ginie rocznie z powodu kolizji z turbinami wiatrowymi',
    whyIShouldUseThisFourTopBefore: '',
    whyIShouldUseThisFourTop: '300',
    whyIShouldUseThisFourTopAfter: 'km/h',
    whyIShouldUseThisFourText: 'prędkość łopaty śmigła',
  },
  farmsPresentation: {
    title: 'Wind farm - bird collisions',
    steps: [{
      title: "Problem kolizji",
      text: "Kolizje z turbinami wiatrowymi zabijają rocznie miliony ptaków i nietoperzy na całym świecie."
    },
      {
        title: "Bioseco BIRD PROTECTION SYSTEM (BPS)",
        text: `Stworzony przez Bioseco system zapobiega kolizjom ptaków z łopatami turbin wiatrowych. System wykrywa i monitoruje ptaki w przestrzeni powietrznej wokół turbiny. Urządzenia są umieszczne w taki sposób aby chronić ptaki na całej farmie wiatrowej.`
      },
      {
        title: "Wykrywanie",
        text: "System wykrywa ptaki w odległości do 500 m od turbiny i analizuje ich wielkość, trajektorię lotu oraz prawdopodobieństwo kolizji."
      },
      {
        title: "Światła ostrzegawcze",
        text: "Jeśli ptaki znajdą się w ustalonej odległości od turbiny, system zaczyna wysyłać jasne stroboskopowe światła w celu ostrzeżenia o zagrożeniu znajdującym się przed nimi."
      },
      {
        title: "Dźwięki ostrzegawcze",
        text: "Dodatkowe sygnały dźwiękowe (syreny lub inne dźwięki ostrzegawcze) są uruchamiane, gdy ptaki kontynuują lot w kierunku turbiny."
      },
      {
        title: "Zatrzymanie turbiny",
        text: "System może dodatkowo wyłączyć lub spowolnić turbinę, jeśli trajektoria lotu ptaków nadal jest kolizyjna z łopatami turbiny. Dzięki temu ptaki mogą bezpiecznie minąć przeszkodę."
      },
      {
        title: "Bezpieczne przejście",
        text: "Ptaki, które ominęły łopaty, są nadal monitorowane. Turbina zaczyna znowu pracować dopiero wtedy, gdy zwierzęta bezpiecznie miną strefę zagrożenia."
      },
      {
        title: "Raportowanie",
        text: "System gromadzi szczegółowe rejestry każdego zdarzenia w celu późniejszej analizy. Zapewnia pełne dane i narzędzia statystyczne dla  użytkowników.<br/><br/><img src='/static/img/product/desktop.jpg' width='200' style='float: right;'><br/><br/>"
      }
    ]
  },
  airportProducts: {
    headerTopText: '<strong>Rozwiązanie</strong><br />dla lotnisk',
    headerTopSubText: '',
    headerTopTextPresentation: 'Rozwiązanie dla lotnisk',
    headerTopSubTextPresentation: 'Zobacz, jak działa nasz innowacyjny system Bioseco AIRPORT FAUNA MONITORING SYSTEM (AFMS)',
    headerText: 'W trosce o bezpieczeństwo pasażerów, Bioseco przygotowało rozwiązanie pomagające redukować liczbę kolizji samolotów z ptakami.',
    whyOurSolutionText: '',
    whyOurSolution: 'Dlaczego nasze rozwiązanie?',
    sectionOneTitle: 'Główne założenie',
    sectionOneText1: 'System urządzeń i oprogramowania zainstalowany na lotnisku',
    sectionOneText2: 'Rozpoznawanie gatunków, wysokości i kierunku przelotu ptaków, zliczanie ptaków',
    sectionOneText3: 'Alerty na tabletach u służb ornitologicznych oraz na wieży kontrolnej',
    sectionOneText4: 'Wyzwolenie akcji – odstraszenie w indywidualny sposób każdego z gatunków – akcja automatyczna lub zatwierdzona manualnie',
    sectionOneText5: 'Zbieranie danych, archiwizowanie w celu generowania statystyk',
    sectionTwoTitle: 'Korzyści',
    sectionTwoText1: 'Zwiększenie poziomu bezpieczeństwa pasażerów',
    sectionTwoText2: 'Obniżenie kosztów związanych z kolizjami z ptakami oraz obniżenie kosztów zapobiegania kolizjom',
    sectionTwoText3: 'Zbieranie danych z długich okresów i możliwość ich różnorodnego wykorzystania, np. zaplanowanie działań w kolejnych sezonach migracyjnych i lęgowych',
    sectionTwoText4: 'Ochrona ptaków',
    sectionTwoText5: 'Zautomatyzowanie części działań',
    sectionTwoText6: 'Ułatwienie pracy służbom lotniskowym',
    sectionTwoText7: 'Lepsze relacje z liniami lotniczymi',
    sectionTwoText8: 'Argument do obniżenia składek ubezpieczeniowych',
    sectionTwoText9: 'Wizerunek firmy dbającej o bezpieczeństwo pasażerów oraz wdrażającej najnowsze, innowacyjne technologie',
    sectionTwoText10: '',
    sectionThreeTitle: 'Technologia',
    sectionThreeText1: 'Małoinwazyjny montaż (wykorzystanie istniejącej infrastruktury)',
    sectionThreeText2: 'Objęcie monitoringiem wszystkich newralgicznych miejsc wokół pasa startowego',
    sectionThreeText3: 'Schemat działania: jednostki zespolone przekazują informacje online do tabletów oraz na serwery, gdzie dokonywana jest analiza danych i archiwizacja',
    sectionThreeText4: 'Rozwiązanie bezpieczne dla komunikacji portu lotniczego, systemów bezprzewodowych i radiowych',
    sectionThreeText5: 'Elastyczność zastosowania – dopasowanie się do specyfiki lotniska',
    whyIShouldUseThis: 'Dlaczego powinno się tego używać?',
    whyIShouldUseThisOneTopBefore: '',
    whyIShouldUseThisOneTop: '65,139',
    whyIShouldUseThisOneTopAfter: '',
    whyIShouldUseThisOneText: 'kolizji samolotów z ptakami zostało zanotowanych w latach 2011-14',
    whyIShouldUseThisTwoTopBefore: '',
    whyIShouldUseThisTwoTop: '92',
    whyIShouldUseThisTwoTopAfter: '%',
    whyIShouldUseThisTwoText: 'kolizji występuje na wysokości poniżej 900m',
    whyIShouldUseThisThreeTopBefore: '',
    whyIShouldUseThisThreeTop: '90',
    whyIShouldUseThisThreeTopAfter: '%',
    whyIShouldUseThisThreeText: 'kolizji występuje w pobliżu lotniska',
    whyIShouldUseThisFourTopBefore: '$',
    whyIShouldUseThisFourTop: '1,2',
    whyIShouldUseThisFourTopAfter: 'mld',
    whyIShouldUseThisFourText: 'koszty kolizji samolotów z ptakami, jakie ponoszą linie lotnicze',
  },
  airportPresentation: {
    title: 'Aircraft-bird collisions',
    steps: [
      {
        title: 'Zderzenie samolot - ptak',
        text: "Zderzenia ptaków z samolotami podczas startów i lądowań powodują rocznie na całym świecie ponad <strong>1,2 miliarda dolarów</strong> strat. Wpływają na konieczność napraw samolotów, opóźnienia w lotach, a przede wszystkim narażają bezpieczeństwo pasażerów i załogi samolotów."
      },
      {
        title: 'Bioseco AIRPORT FAUNA MONITORING SYSTEM (AFMS)',
        text: "System jest zainstalowany w odległości ok. 200 m od pasa startowego i wykrywa ptaki lecące w kluczu w promieniu 300 m."
      },
      {
        title: 'Monitorowanie',
        text: "System monitoruje aktywność ptaków, a pozyskane  informacje wysyłane są w czasie rzeczywistym do służb odpowiedzialnych za  bezpieczeństwo na lotnisku."
      },
      {
        title: 'Ostrzeganie',
        text: "Na podstawie informacji uzyskanych z Systemu Bioseco służby odpowiedzialne za ochronę lotniska podejmują odpowiednie działania zapobiegawcze."
      },
      {
        title: 'Oprogramowanie',
        text: "System bazodanowy zbiera informacje o wszystkich zdarzeniach umożliwiając łatwe generowanie raportów i analizę wszystkich zdarzeń. Dodatkowo informacje o wykrytych obiektach w czasie rzeczywistym wyświetlane są u pracowników służby ochrony na urządzeniach mobilnych."
      },
      {
        title: 'Obserwacja 360°',
        text: "W zależności od ilości modułów System Bioseco dla lotnisk umożliwia obserwację do 360°. Detektory są umieszczone w szczelnych i odpornych na niekorzystne warunki atmosferyczne obudowach."
      },
      {
        title: 'Bezpieczny start i lądowanie',
        text: "Używane podzespoły nie kolidują z infrastrukturą komunikacyjną na lotnisku. Technologia Bioseco dla lotnisk jest elastyczna, łatwo ją dostosować do konkretnych potrzeb oraz warunków każdego lotniska."
      }
    ]
  },
  areaProducts: {
    headerTopText: '<strong>Rozwiązanie</strong><br />dla ornitologów',
    headerTopSubText: '',
    headerTopTextPresentation: 'Rozwiązanie dla ornitologów',
    headerTopSubTextPresentation: 'Zobacz, jak działa nasz innowacyjny system Bioseco BIRD PROTECTION SYSTEM (BPS)',
    headerText: 'Technologie, tworzone przez Bioseco, oprócz zastosowań na farmach wiatrowych, czy lotniskach, mogą stać się przydatnym narzędziem dla ornitologów. Otrzymują oni urządzenie, pozwalające na pozyskanie bardzo precyzyjnych, w pełni wiarygodnych i uznawanych przez ekspertów danych. Dzięki Bioseco BIRD PROTECTION SYSTEM (BPS) można nieprzerwanie rejestrować wszystkie informacje dotyczące przelatujących ptaków. W wyniku automatycznej analizy wykrytych przez Bioseco BIRD PROTECTION SYSTEM (BPS) zdarzeń otrzymuje się niepodważalne, zrozumiałe i nieusuwalne dane.',
    whyOurSolutionText: '',
    whyOurSolution: 'Co możesz uzyskać?',
    sectionOneTitle: 'Główne założenia',
    sectionOneText1: 'Oprogramowanie Bioseco pozwala na analizę w czasie rzeczywistym i stały dostęp do zapisanych informacji za pośrednictwem strony internetowej lub dowolnego urządzenia mobilnego.',
    sectionOneText2: 'Olbrzymia ilość danych daje możliwość porównania różnych parametrów dotyczących przelatujących ptaków. Z wykorzystaniem systemu BIRD PROTECTION SYSTEM (BPS) Twoje badania lub raport środowiskowy mogą być wykonane szybciej i bardziej wiarygodnie, przy użyciu najnowocześniejszych systemów IT.',
    sectionTwoTitle: 'Jak to działa?',
    sectionTwoText1: 'wykrywanie ptaków przelatujących w promieniu 300 m',
    sectionTwoText2: 'Główne cechy systemu BIRD PROTECTION SYSTEM (BPS):',
    sectionTwoText3: 'określanie wysokości przelotu, prędkości, kierunku lotu oraz odległości ptaka od urządzenia',
    sectionTwoText4: 'zapis danych środowiskowych oraz meteorologicznych w odniesieniu do daty i godziny',
    sectionTwoText5: 'kompaktowe urządzenie zdolne do pracy w każdym terenie: lasy, góry lub morze',
    sectionTwoText6: 'nagrywanie 24 h na dobę w jakości HD ',
    sectionTwoText7: '',
    whyIShouldUseThis: 'Dlaczego powinno się tego używać?',
    whyIShouldUseThisOneTopBefore: '',
    whyIShouldUseThisOneTop: '450',
    whyIShouldUseThisOneTopAfter: '',
    whyIShouldUseThisOneText: 'gatunków ptaków w Polsce',
    whyIShouldUseThisTwoTopBefore: '',
    whyIShouldUseThisTwoTop: '26',
    whyIShouldUseThisTwoTopAfter: '',
    whyIShouldUseThisTwoText: 'gatunków nietoperzy w Polsce',
    whyIShouldUseThisThreeTopBefore: '',
    whyIShouldUseThisThreeTop: '10000',
    whyIShouldUseThisThreeTopAfter: 'km',
    whyIShouldUseThisThreeText: 'pokonują bociany w trakcie migracji',
    whyIShouldUseThisFourTopBefore: '',
    whyIShouldUseThisFourTop: '5000',
    whyIShouldUseThisFourTopAfter: '',
    whyIShouldUseThisFourText: 'birdwatcherów w Polsce',
  },
  areaPresentation: {
    title: 'Rozwiązanie dla ornitologów',
    steps: [{
      title: "Badania środowiskowe",
      text: "Bioseco BIRD PROTECTION SYSTEM (BPS) to narzędzie dla ornitologów, idealnie nadające się do  monitoringu ptaków w przestrzeni powietrznej. Wykrywa je z odległości nawet 500 m, rejestrując m.in. wysokość, prędkość, czy kierunek ich przelotu. Otrzymywane dane są w pełni wiarygodne, precyzyjne oraz uznawane przez ekspertów oraz instytucje."
    }
    ]
  },
  contact: {
    stayInContact: 'Pozostańmy w kontakcie',
    newBuilding: '(nowy budynek PPNT)',
    haveQuestions: 'Masz pytania? Kliknij tutaj',
    pl: 'Polska',
    street: 'Ul. Budowlanych 68',
    account: 'nr konta',
    project: 'Projekty dofinansowane z UE'
  },
  component: {
    moreAboutUs: 'Dowiedz się więcej',
    watchPresentation: 'Zobacz prezentację',
    watchPromoVideo: 'Zobacz film promocyjny',
    watchBooklet: 'Pobierz broszurę',
    bookletPolish: 'język polski',
    bookletEnglish: 'język angielski',
    bookletDeutch: 'język niemiecki',
    bookletFrench: 'język francuski',
    bookletJapanese: 'język japoński',
    watchVideo: 'Zobacz video',
    watchExampleVideo: 'Zobacz rzeczywisty przykład działania BPS',
    watchUs: 'Zobacz nas<br /><strong>w akcji</strong>',
    moreInfo: 'Potrzebujesz więcej informacji?',
    askAboutMore: 'Zapytaj o więcej'
  },
  questionModal: {
    haveQuestion: 'Masz pytania?',
    completeForm: 'Wypełnij poniższy formularz, z przyjemnością odpowiemy:',
    name: 'Imię i Nazwisko',
    email: 'Adres e-mail',
    queryTopicText: 'Wybierz temat zapytania',
    queryTopic: {
      questionOne: 'Produkty dla farm wiatrowych',
      questionTwo: 'Produkty dla lotnisk',
      questionThree: 'Produkty dla ornitologów',
      questionFour: 'Współpraca',
      questionFive: 'Zapytanie ogólne'
    },
    content: 'treść',
    errorMsg: 'Uzupełnij brakujące pola',
    errorSendMsg: 'Błąd podczas wysyłania',
    sendMsg: 'Wysłano formularz',
    send: 'Wyślij',
    rodo: `Administratorem Państwa danych osobowych ujawnionych w powyższym formularzu kontaktowym jest
          Bioseco Spółka akcyjna z siedzibą w Gdańsku (80-298), ul. Budowlanych 68.
          Dane osobowe ujawnione w niniejszym formularzu będą przetwarzane w celu obsługi przesłanego zapytania na
          podstawie prawnie uzasadnionego interesu administratora tj. art. 6 ust. 1 lit. f RODO, polegającego na dbaniu
          o jakość swoich usług i komunikację. Przysługuje Państwu żądanie dostępu do swoich danych osobowych, ich
          sprostowania, usunięcia lub ograniczenia przetwarzania.
          Ponadto przysługuje Państwu wniesienie sprzeciwu wobec przetwarzania swoich danych osobowych oraz prawo do
          wniesienia skargi do organu nadzorczego- Prezesa Urzędu Ochrony Danych Osobowych. Więcej informacji na temat
          przetwarzania Państwa danych osobowych znaleźć możecie w Naszej Polityce prywatności zamieszczonej pod
          adresem: `,
    rodoLink: 'Polityka prywatności',
  },
  mediaBox: {
    title: "Media o nas",
    mediaBoxes: [
      {
        img: "/static/img/media/img1.jpg",
        title: "GAZETA WYBORCZA",
        text: "główna gazeta codzienna, artykuł o systemie farm wiatrowych <span class=arrow></span>",
        link: "http://wyborcza.biz/biznes/1,147584,20695368,bioseco-odstrasza-ptaki-a-przyciaga-inwestorow.html",
        type: "text-type"
      },
      {
        img: "/static/img/media/img4.jpg",
        title: "PULS BIZNESU",
        text: "czołowy dziennik biznesowy, artykuł o systemie na lotnisku w Gdańsku <span class=arrow></span>",
        link: "http://pulsbiznesu.pb.pl/3867943,56421,bioseco-ochroni-samoloty-przed-ptakami",
        type: "text-type"
      },
      {
        img: "/static/img/media/img7.jpg",
        title: "TVN24",
        text: "telewizyja informacyjna, wiadomość o współpracy Bioseco i PGE SA <span class=arrow></span>",
        link: "http://tvn24bis.pl/z-kraju,74/powstaje-system-do-monitorowania-ptakow-w-poblizy-farm-wiatrowych,517386.html",
        type: "text-type"
      },
      {
        img: "/static/img/media/img5.jpg",
        title: "PGE SA",
        text: "strona internetowa PGE SA, oświadczenie o współpracy z Bioseco <span class=arrow></span>",
        link: "http://www.gkpge.pl/biuro-prasowe/komunikaty-prasowe/inne/multirejestratory-beda-monitorowac-ptaki-na-terenie-farm-wiatrowych-pge",
        type: "text-type"
      },

    ]
  },
  media: {
    description: "Zobacz nas w akcji",
  },
  infoBox: {
    title: "Media o nas",
    newsTitle: "Aktualności",
    archiveTitle: "Archiwum",
    linkDescription: "Czytaj więcej : ",
    postedDescription: "Aktualizacja: ",
    infoBoxes: [
      {
        img: "/static/img/media/Bioseco_RFQ.png",
        title: "Zaproszenie do składania ofert. Zapytanie ofertowe PMT/4/2021.",
        text: "W związku z udziałem w programie Polskie Mosty Technologiczne organizowanym przez Polską Agencję Inwestycji i Handlu, w ramach Programu Operacyjnego Inteligentny Rozwój 2014-2020; oś priorytetowa III Wsparcie innowacji w przedsiębiorstwach, działanie 3.3 Wsparcie promocji oraz internacjonalizacji innowacyjnych przedsiębiorstw, poddziałanie 3.3.1 Polskie Mosty Technologiczne, Bioseco sp.z o.o. zaprasza do składania ofert na wykonanie usług zleconych wg podanej w załączniku specyfikacji. <br/><br /> Załącznik: <a download href='/static/RFQ_PMT.4.2021_Bioseco.docx.pdf'>RFQ_PMT.4.2021_Bioseco.pdf</a>",
        type: "text-type",
        date: "02.04.2021"
      },
      {
        img: "/static/img/media/Bioseco_RFQ.png",
        title: "Wybór oferty. Zapytanie ofertowe PMT/1/2021.",
        text: "W związku z udziałem w programie Polskie Mosty Technologiczne organizowanym przez Polską Agencję Inwestycji i Handlu, w ramach Programu Operacyjnego Inteligentny Rozwój 2014-2020; oś priorytetowa III Wsparcie innowacji w przedsiębiorstwach, działanie 3.3 Wsparcie promocji oraz internacjonalizacji innowacyjnych przedsiębiorstw, poddziałanie 3.3.1 Polskie Mosty Technologiczne, Bioseco sp.z o.o. wybrało najkorzystniejszą ofertę złożoną w odpowiedzi na zapytanie ofertowe PMT/1/2021. Oferantem jest American Wind Wildlife Institute (AWWI),  siedzibą w Washingotn DC, USA (1990 K Street NW, 20006), z zamówieniem na kwotę 8,850,51 USD.<br/><br /><img src='/static/img/RFQ_PMT.1.2021_Bioseco.png' alt='RFQ_PMT'/>",
        type: "text-type",
        date: "03.02.2021"
      },
      {
        img: "/static/img/media/Bioseco_RFQ.png",
        title: "Zaproszenie do składania ofert. Zapytanie ofertowe PMT/1/2021.",
        text: "W związku z udziałem w programie Polskie Mosty Technologiczne organizowanym przez Polską Agencję Inwestycji i Handlu, w ramach Programu Operacyjnego Inteligentny Rozwój 2014-2020; oś priorytetowa III Wsparcie innowacji w przedsiębiorstwach, działanie 3.3 Wsparcie promocji oraz internacjonalizacji innowacyjnych przedsiębiorstw, poddziałanie 3.3.1 Polskie Mosty Technologiczne, Bioseco sp.z o.o. zaprasza do składania ofert na wykonanie usług zleconych wg podanej w załączniku specyfikacji.<br/><br /><img src='/static/img/RFQ_PMT.1.2021_Bioseco.png' alt='RFQ_PMT'/><br/><br /> Załącznik: <a download href='/static/RFQ_PMT.1.2021_Bioseco.pdf'>RFQ_PMT.1.2021_Bioseco.pdf</a> ",
        type: "text-type",
        date: "22.01.2021"
      },
      {
        img: "/static/img/media/spain_december.jpg",
        title: "Kolejny system w Hiszpanii. ",
        text: "Zainstalowaliśmy właśnie systemy ochrony ptaków w okolicy Kadyksu. System działa na farmie wiatrowej, na której monitoring był prowadzony stacjonarnie, przez obserwatorów. W przypadku przelotów ptaków manualnie wysyłali sygnał zatrzymania turbiny.",
        type: "text-type",
        date: "17.12.2020"
      },
      {
        img: "/static/img/media/bioseco_france.jpg",
        title: "Bioseco wchodzi na nowy rynek – Francja!",
        text: "W tym tygodniu zainstalowaliśmy nasze trzy systemy BPS we Francji. Cieszymy się, że taka firma jak WPO zdecydowała się na ochronę ptaków przy wsparciu Bioseco. Po raz pierwszy nasze urządzenia pracują na turbinach Gamesa. \n" +
          "Nowa generacja systemu stereowizyjnego umożliwia szacowanie odległości i klasyfikację wielkości ptaków oraz filtrowanie fałszywych zdarzeń. Dodatkowo wspomaganie sztuczną inteligencją ograniczy do minimum niepotrzebne zatrzymania turbin i straty w wytwarzaniu energii.",
        type: "text-type",
        date: "23.11.2020"
      },
      {
        img: "/static/img/media/mosty_technologiczne.jpg",
        title: "Bioseco otrzymało dofinansowanie w ramach projektu Polskie Mosty Technologiczne",
        text: "Projekt Polskie Mosty Technologiczne Polskiej Agencji Inwestycji i Handlu ma na celu wsparcie promocji oraz internacjonalizacji innowacyjnych przedsiębiorstw. Za takie przedsiębiorstwo zostało uznane Bioseco. W ramach naboru „V/2019: Chiny, Stany Zjednoczony, ZEA” Bioseco dostało 200tys PLN finansowania na eksplorację rynku Stanów Zjednoczonych. ",
        type: "text-type",
        date: "14.11.2020"
      },
      {
        img: "/static/img/media/photonics.jpg",
        title: "Wyróżnienie dla Bioseco w programie Tech Tour Photonics",
        text: "Bioseco znalazło się w gronie zwycięzców tegorocznej edycji programu Tech Tour Photonics. Tech Tour ma swoje korzenie w Brukseli i Genewie, a w konkursie brały udział innowacyjne firmy z całej Europy. ",
        type: "text-type",
        date: "02.11.2020"
      },
      {
        img: "/static/img/media/bioseco_kreatywni.jpg",
        title: "Sukces Bioseco na gali 50 Najbardziej Kreatywnych Ludzi w Biznesie",
        text: "Krzysztof Paszek znalazł się szacownym gronie 50 Najbardziej Kreatywnych Ludzi w Biznesie i zajął wśród wyróżnionych zaszczytne drugie miejsce. Jubileuszowa Gala odbyła się pod egidą Ministerstwa Rozwoju i wielu uznanych firm oraz instytucji, takich jak: PKN ORLEN, Millennium Leasing, E. Wedel, Google for Startups, Krajowa Izba Gospodarcza i wielu innych.\n" +
          "Więcej zobaczyć można <a href='https://www.youtube.com/watch?v=0OX_B1NL10Y' target='_blank'>tutaj</a>.",
        type: "text-type",
        date: "28.09.2020"
      },
      {
        img: "/static/img/media/bioseco_ce.jpg",
        title: "Certyfikat CE",
        text: "Z przyjemnością informujemy, że nasz system BPS przeszedł rygorystyczne testy i sprostał wymaganiom UE dotyczącym sprzętu elektrycznego. Mogliśmy wystawić deklarację zgodności UE i od teraz urządzenia Bioseco posiadają oznakowanie CE.",
        type: "text-type",
        date: "01.09.2020"
      },
      {
        img: "/static/img/media/photo_cooperation.jpg",
        title: "Bioseco wchodzi do Austrii poprzez pozyskanie Partnera lokalnego – Energiwerkstatt",
        text: "Niedawno Bioseco + Windhunter + Energiewerkstatt uzgodniły warunki współpracy w zakresie sprzedaży systemów ochrony ptaków Bioseco  w Austrii.\n" +
          "W zeszłym tygodniu Florian Lachinger (Energiewerkstatt) i Maciej Łaz (Windhunter Service) odwiedzili siedzibę Bioseco, a następnie pojechaliśmy wspólnie aby zobaczyć system Bioseco działający na farmie wiatrowej.\n" +
          "Mamy nadzieję, że ta współpraca przyniesie wymierne rezultaty dla wszystkich zaangażowanych, a także finalnie przyczyni się do wzrostu poziomu ochrony ptaków.",
        date: "30.07.2020"
      },
      {
        img: "/static/img/media/gwo.jpg",
        title: "Ekipa Bioseco przeszkolona w standardach GWO przez Windhunter",
        text: "Ekipa instalacyjna i techniczna Bioseco została niedawno przeszkolona przez naszego Partnera – Windhunter zgodnie ze standardami GWO. <br />Podczas zwiększania zasięgu i ilości operacji musimy pamiętać o zapewnieniu bezpieczeństwa i najwyższych standardów działania.",
        type: "text-type",
        date: "21.07.2020"
      },
      {
        img: "/static/img/media/bps_germany.jpg",
        title: "Ważna instalacja w Niemczech dla BayWa r.e.",
        text: "Bioseco zainstalowało dwa systemy ochrony ptaków w ramach projektu pilotażowego w Niemczech we współpracy z dużym deweloperem i operatorem farm wiatrowych BayWa r.e.\n" +
          "Obie strony mają wysokie oczekiwania co do poziomu ochrony ptaków i jednoczesnego ograniczenia niepotrzebnych przestojów, a tym samym zwiększenia efektywności produkcji energii.\n" +
          "Zarówno zespół Bioseco, jak i BayWa r.e. z niecierpliwością czekają na mierzalne efekty, które wniosą wkład do toczącej się obecnie w Niemczech dyskusji o ochronie ptaków na farmach wiatrowych.",
        type: "text-type",
        date: "15.05.2020"
      },
      {
        img: "/static/img/media/wspolpraca-pgeeo.jpg",
        video: "/static/video/bird_tracking.mp4",
        poster: "/static/video/poster_bird_tracking.png",
        title: "Przykładowe wykrycie nagrane w Niemczech",
        text: "Niedawno zainstalowaliśmy 2 nowe systemy Ochrony Ptaków (Bird Protection Systems) w Niemczech z ulepszonym oprogramowaniem. Niedługo po instalacji system zarejestrował przelot średniej wielkości ptaka.",
        type: "text-type",
        date: "04.06.2020"
      },
      {
        img: "/static/img/media/installation.jpg",
        video: "/static/video/Bioseco_PL_small.mp4",
        poster: "/static/video/poster.png",
        title: "Rozpoczęliśmy testy system Bioseco na farmie PGE EO",
        text: "Pomimo epidemii koronawirusa. Bioseco kontynuuje swoją misję ratowania ptaków i ochrony inwestorów przed negatywnymi konsekwencjami kolizji ptaków z turbinami wiatrowymi. Przygotowaliśmy dla Was krótki film z naszego ostatniego montażu na jednej z największych farm wiatrowych w Polsce, gdzie zainstalowaliśmy nasz najnowszy ośmio-modułowy system ochrony ptaków.\n" +
          "<br/>Kolejne instalacje systemu Bioseco planujemy na maj 2020, tym razem w Niemczech.\n" +
          "<Br/>Pozostańcie w zdrowiu.",
        type: "text-type",
        date: "20.03.2020"
      },
      {
        img: "/static/img/media/wfo2020.png",
        title: "Bioseco wzięło udział w 4tym Forum Operatorów Farm Wiatrowych",
        text: "Bioseco wzięło udział w 4 edycji Forum Operatorów Farm Wiatrowych w Sopocie (www.wfof.eu). Oprócz prezentacji systemu Ochrony Ptaków w czasie minitargów, nasz CEO - Adam Jaworski przedstawił  szczegóły działania systemu w czasie warsztatów poprowadzonych razem z Michałem Kaczerowskim z doświadczonej pracowni środowiskowej Ambiens. \n" +
          "<Br/>Dla zainteresowanych osób jest możliwość uzyskania prezentacji i filmu z warsztatów. \n" +
          "<br/>Napiszcie na offers@bioseco.com",
        type: "text-type",
        date: "12.03.2020"
      },
      {
        img: "/static/img/media/test2020.jpg",
        title: "Świetne wyniki ewaluacji system Ochrony ptaków w Niemczech.",
        text: "Otrzymaliśmy raport z ewaluacji naszego systemu wykonany przez Vogelwarte w ramach kampanii testowej z września/października 2019r. Nasz ośmio modułowy system był testowany w ramach programu NatForWinSent prowadzonego przez ZSW i finansowaniu rządu niemieckiego (<a href='https://www.natur-und-erneuerbare.de/projektdatenbank/projekte/natforwinsent-ii/'>https://www.natur-und-erneuerbare.de/projektdatenbank/projekte/natforwinsent-ii/</a>).\n" +
          "Skuteczność wykrywania Kanii Rudej osiągnęła 97% w promieniu 200m od systemu. Skumulowana skuteczność w granicach 0-300m wyniosła 83% a w obrębie do 400m od systemu ok. 64%.\n" +
          "Kolejną dobrą wiadomością była bardzo niska wartość fałszywych wykryć która wyniosła jedynie 7%, z czego tylko 1/3 doprowadziłaby do zatrzymania turbiny, co jest efektem zastosowania stereowizji i zaawansowanych algorytmów detekcji.  ",
        type: "text-type",
        date: "07.02.2020"
      },
      {
        img: "/static/img/media/xmas.jpg",
        title: "Prezent na gwiazdkę. 2 systemy z dostawą do Polski sprzedane.",
        text: "Świetny prezent na gwiazdkę. Bioseco podpisało 2 umowy z polskim developerem farm wiatrowych na dostawę 2 Systemów Ochrony Ptaków dla 2 projektów w Polsce, które będą realizowane w 2 połowie 2020. Zgodnie z wymogami dwie turbiny Vestas powinny być wyposażone w system chroniący ptaki i zatrzymujący turbinę, gdy ptaki zbliżą się na odległość mniejszą niż 150 m od turbiny wiatrowej. Już nie możemy się doczekać momentu realizacji tej Umowy. \n" +
          "Wesołych Świąt i Szczęśliwego Nowego Roku.",
        type: "text-type",
        date: "23.12.2019"
      },
      {
        img: "/static/img/media/reon.jpg",
        title: "Bioseco i  REON AG podpisują umowę partnerską na Niemcy",
        text: "Bioseco i Reon AG podpisały umowę o współpracy w ramach której REON AG będzie autoryzowanym agentem Bioseco w Niemczech. Mając na uwadze wieloletnią obecność Reon na rynku energetyki wiatrowej W Niemczech, szeroką sieć kontaktów i profesjonalne podejście, Umowa ta stworzy dobre warunki do wejścia Bioseco na najważniejszy na ten moment rynek w Europie. Oczekujemy na szybkie efekty tej współpracy. ",
        type: "text-type",
        date: "20.12.2019"
      },
      {
        img: "/static/img/media/bird-tests.jpg",
        title: "Kolejny test systemu Ochrony Ptaków tym razem z użyciem trenowanych sokołów",
        text: "3 tygodnie temu System Bioseco był testowany z pomocą sztucznego ptaka. W zeszłym tygodniu System Ochrony Ptaków Bioseco zainstalowany na turbinie wiatrowej w Polsce był testowany z pomocą trenowanego sokoła. We wszystkich przelotach system wykrył ptaka i zatrzymał turbinę. Gratulacje dla całego zespołu Bioseco w potwierdzeniu skuteczności działania systemu w tym teście i całego trudu włożonego w rozwój systemu w 2019r. ",
        type: "text-type",
        date: "13.12.2019"
      },
      {
        img: "/static/img/media/bird.jpg",
        title: "System Ochrony Ptaków Bioseco testowany w Hiszpanii przez globalnego gracza",
        text: "Zastanawiacie się co to jest? System Ochrony Ptaków Bioseco był niedawno testowany na jednej z farm wiatrowych w Hiszpanii należących do globalnego operatora farm wiatrowych. W czasie testu system wykrywał drona przypominającego ptaka, który właśnie jest na zdjęciu. Testy przebiegły bardzo dobrze potwierdzając wysoką sprawność detekcji i zdolność systemu do szacowania odległości pomiędzy dronem a turbiną wiatrową. Właśnie ta cecha jest niezwykle ważna dla operatorów farm wiatrowych aby skutecznie unikać kolizje jednocześnie minimalizując czas wyłączenia turbin. Czekamy na nowe firmy gotowe przetestować system Bioseco z pomocą żywych czy sztucznych ptaków. Więcej dobrych wiadomości niebawem.",
        type: "text-type",
        date: "03.12.2019"
      },
      {
        img: "/static/img/media/installation.jpg",
        title: "Kolejna instalacja system ochrony ptaków Bioseco w Polsce",
        text: "W zeszłym tygodniu ekipa Bioseco zainstalowała najnowszy System Ochrony Ptaków na turbinie wiatrowej w Polsce. Kolejna bezpieczna dla ptaków turbina wiatrowa i kolejny inwestor chroniony przeciwko ryzyku związanemu ze śmiertelnością ptaków, a zarazem krok w kierunku komercjalizacji Systemu Ochrony Ptaków. Oczekujemy na nowe wyzwania w zakresie ochrony ptaków.",
        type: "text-type",
        date: "18.10.2019"
      },
      {
        img: "/static/img/media/airports.png",
        title: "Umowa na dofinansowanie w kwocie 2,6 milliona złotych na system lotniskowy podpisana",
        text: "Podpisaliśmy Umowę o dofinansowanie z NCBiR (Narodowe Centrum Badań i Rozwoju) umowy na dofinansowanie projektu badawczego o nazwie „Przeprowadzenie prac badawczo-rozwojowych niezbędnych do opracowania nowego autonomicznego systemu AIRPORT FAUNA MONITORING SYSTEM (AFMS) redukującego liczbę kolizji statków powietrznych z ptakami i ssakami.” W ramach projektu Bioseco ma wytworzyć w pełni funkcjonalny produkt, który ma zwiększyć bezpieczeństwo na lotniskach w zakresie zarządzania ryzykiem środowiskowym. Projekt będzie realizowany w latach 2020-2022. \n" +
          "<Br/><br/>Wartość projektu to prawie 3,5mln złotych, a wartość dofinansowanie to ponad 2,6mln złotych.\n" +
          "<br/><br/>W ten sposób Bioseco kontynuuje inwestycję w swoją drugą linię biznesową poświęconą bezpieczeństwu na lotniskach.",
        type: "text-type",
        date: "30.09.2019"
      },
      {
        img: "/static/img/media/wspolpraca-pgeeo.jpg",
        title: "Współpraca z PGE EO oficjalna",
        text: "To już oficjalne. PGE EO (największy operator farm wiatrowych w Polsce) będzie testował systemy Bioseco na swoich farmach wiatrowych. To znaczący krok w kierunku redukcji negatywnego wpływu energetyki wiatrowej na duże ptaki oraz w rozwoju Systemu Ochrony Ptaków Bioseco. Aby przeczytać więcej zajrzyj na",
        link: "https://pgeeo.pl/Aktualnosci/kamery-i-radary-beda-monitorowac-ptaki",
        type: "text-type",
        date: "04.09.2019"
      },
      {
        img: "/static/img/media/pozytywny.jpg",
        title: "Raport Startupów Pozytywnego Wpływu 2019",
        text: "Chcielibyśmy podziękować Kozminski Business Hub za przedstawienie Nas w Raporcie Startupów Pozytywnego Wpływu 2019. Raport ten jest zbiorem polskich firm, które zajmują się tworzeniem wartości na rzecz zrównoważonego rozwoju. Bioseco trafiło do grona Startupów które cechują się innowacyjnością oraz dużymi możliwościami zwiększenia swojego działania.<br/><br/>Zapraszamy do zapoznania się z raportem.<br/>Informacje o Naszej firmie znajdują się na stronach 69-71.",
        link: "http://raportspw.kozminskihub.com/",
        type: "text-type",
        date: "30.04.2019"
      },
      {
        img: "/static/img/media/upgrade.jpg",
        title: "Update Systemu",
        text: "W ubiegłym tygodniu nasz zespół zaktualizował systemy na farmie wiatrowej zlokalizowanej na południu Polski.<br />Sześć naszych modułów zostało wymienionych na nową generację systemu ochrony ptaków.<br /><br />Zaktualizowane systemy są wyposażone w moduły umożliwiające odtwarzanie dowolnych dźwięków - od syren po odgłosy ptaki drapieżnych, z regulowaną głośnością aż do 120dB.<br />Moduł wizualny może mierzyć odległość ptaków od wiatraka a dzięki 3 zainstalowanym kamerom zapewnia obraz o wysokiej rozdzielczości.<br /><br />Jesteśmy przekonani, że nowy system przyniesie wspaniałe efekty!",
        link: "https://www.linkedin.com/company/bioseco/",
        type: "text-type",
        date: "05.04.2019"
      },

      {
        img: "/static/img/media/move.jpg",
        title: "Przeprowadzka Bioseco!",
        text: "Można Nas znaleźć w nowej lokalizacji, kilka minut od gdańskiego lotniska.<br /> Wraz z powiększeniem przestrzeni, łatwiej nam rozbudowywać nasz system i rozwijać naszą organizację.<br />Nowy adres to <strong>Budowlanych 68, Gdańsk</strong>.<br /><br />Zapraszamy!",
        link: "https://www.linkedin.com/feed/update/urn:li:activity:6523494951689560064",
        type: "text-type",
        date: "29.04.2019"
      },

      {
        img: "/static/img/media/wolves.jpg",
        title: "Wolves summit",
        text: "Wolves Summit był wielkim sukcesem dla Bioseco.<br />Zakwalifikowanie się do półfinału konkursu Great Pitch jest potwierdzeniem zainteresowania naszą organizacją.<br />Przeprowadzone rozmowy i ciekawe spotkania, które odbyły się podczas wydarzenia pomagają rozwijać się zespołowi Bioseco.",
        link: "https://www.linkedin.com/feed/update/urn:li:activity:6513820388680626176",
        type: "text-type",
        date: "21.04.2019"
      },

      {
        img: "/static/img/media/n_img1.jpg",
        title: "IEEE N3XT® STARS",
        text: "Zrobiliśmy to! Bioseco właśnie stało się członkiem programu innowacji stworzonego przez EUtop50.<br />Organizacja wspiera młode firmy, które są zaangażowane w tworzenie produktów i technologii, które mają wpływ na potrzeby Europy.   Organizacja jest gospodarzem wydarzenia IEEE N3XT® STARS. O wyborze zwycięzców decydują innowacyjne produkty korzystne dla ludzkości, oparte na inżynierii, zgodne ze standardami IEEE.<br /> Z przyjemnością informujemy, że Bioseco zostało nagrodzone w 2018 roku IEEE N3XT® STARS.<br /> Bycie częścią tak prestiżowej grupy potwierdza nasze przekonanie, że nasze działania wpłyną pozytywnie na otaczający nas świat.<br /> Dziękujemy za nagrodę, która zachęca nasz zespół do ciągłego doskonalenia!",
        link: "https://entrepreneurship.ieee.org/n3xt-stars/",
        type: "text-type",
        date: "28.01.2019"
      },

      {
        img: "/static/img/media/top50.jpg",
        title: "Konkurs EUtop50",
        text: "<span class=strong>Właśnie wygraliśmy prestiżowy konkurs EUtop50 w Parlamencie Europejskim w Brukseli!</span><br /><span class=strong>Platforma EUtop50</span> została zorganizowana przy okazji 10. Europejskiego Szczytu Innowacyjności oraz konferencji wysokiego szczebla UE w dziedzinie nauki i innowacji.<br /><span class=strong>Bioseco</span> było jedynym startupem reprezentującym Polskę i jednym z dwóch reprezentujących Europę Środkowo-Wschodnią. <br />Wydarzenie to łączy najlepsze europejskie startupy, wybitnych naukowców, polityków, inwestorów i przedstawicieli biznesu. <br />Nagroda potwierdza, że ​​nasze rozwiązanie zmierza w dobrym kierunku ochrony środowiska dzięki naszej innowacyjnej technologii.",
        link: "https://www.facebook.com/pg/Bioseco-497515667013273/posts/?ref=page_internal",
        type: "text-type",
        date: "29.11.2018"
      },
      {
        img: "/static/img/media/sonda2.jpg",
        title: "Innowacja Bioseco zaprezentowana w programie „Sonda 2”",
        text: "W odcinku programu „Sonda 2”, poświęconym w całości ptakom, został przedstawiony problem ich śmiertelności na farmach wiatrowych. Mogliśmy przekazać jak można (i trzeba!) ratować ptaki przed śmiercią w wyniku zderzenia z łopatami turbin. Program został wyemitowany na antenie telewizyjnej Dwójki. Do obejrzenia <a href='https://vod.tvp.pl/video/sonda-2,odc-86-ptaki,37095018' target='_blank'>tutaj</a>",
        type: "text-type",
        date: "25.05.2018"
      },
      {
        img: "/static/img/media/scale_up.jpg",
        title: "Bioseco bierze udział w programie KPT ScaleUP w Krakowie",
        text: "Zespół Bioseco, dzięki uczestnictwu w programie KPT ScaleUP, mógł nawiązać kontakty z przedstawicielami Portu Lotniczego Kraków, przetestować prototypy, jak również wziąć udział w całej serii spotkań i szkoleń. ",
        type: "text-type",
        date: "05.08.2017"
      },
      {
        img: "/static/img/media/bird-strike.jpg",
        title: "Kongres World Birdstrike Association w Amsterdamie",
        text: "Przedstawiciele Bioseco wzięli udział w najważniejszym spotkaniu branży związanej z kolizjami ptaków z samolotami. Jest to zagadnienie nad wyraz istotne, gdyż rocznie generuje straty ponad dwóch miliardów dolarów. Istnieją organizacje i zrzeszenia, które integrują ekspertów zajmujących się tym tematem. Dla Bioseco to była cenna nauka i szansa na kontakty z najważniejszymi ludźmi z branży, które z pewnością zaprocentują w przyszłości. ",
        type: "text-type",
        date: "06.12.2016"
      },
      {
        img: "/static/img/media/kongres.jpg",
        title: "Spotkania na Kongresie 590 w Rzeszowie",
        text: "Bioseco zostało zaproszone do grona innowacyjnych firm, które rozmawiały z przedstawicielami rządu oraz biznesu. Wśród spotkanych osób był również Bruce Dickinson – właściciel firmy Cardiff Aviation i jednocześnie wokalista zespołu Iron Maiden.",
        type: "text-type",
        date: "17.11.2016"
      },
      {
        img: "/static/img/media/tedx.jpg",
        title: "Misja Bioseco przedstawiona na TEDx \"Między gatunkami\" – Gdynia ",
        text: "To był zaszczyt móc przedstawić audytorium intelektualistów zagadnienie ochrony ptaków na farmach wiatrowych i opisać sposób rozwiązania, nad którym pracuje zespół Bioseco. ",
        type: "text-type",
        date: "26.11.2015"
      },
      {
        img: "/static/img/media/innowacje-tvp.jpg",
        title: "Bioseco w programie „Innowacje dla Ciebie” w TVP",
        text: "W popularnym programie „Innowacje dla Ciebie” red. Romana Młodkowskiego wraz z prezesem Technoparku, prof. Janem Kosmolem, Krzysztof Paszek z Bioseco rozmawiał o innowacjach, wsparciu biznesu i przede wszystkim prezentował koncepcję rozwiązania Bioseco. ",
        type: "text-type",
        date: "17.08.2015"
      },
      {
        img: "/static/img/media/horyzont2020.jpg",
        title: "Bioseco zdobyło dotację Horyzont 2020",
        text: "Konsorcjum trzech firm, wśród których znalazło się Bioseco, zdobyło grant z programu Horyzont 2020, SME Instrument Faza 1. Eksperci Komisji Europejskiej na tyle wysoko ocenili projekt detekcji dronów, że znalazł się on w pierwszej dziesiątce projektów z Polski, którym ten grant został przyznany. ",
        type: "text-type",
        date: "10.06.2015"
      },
      {
        img: "/static/img/media/mobile-kongres.jpg",
        title: "Udział w Mobile World Congress w Barcelonie",
        text: "Już po raz drugi Bioseco wzięło udział jako wystawca na słynnych targach MWC w Barcelonie. Wśród innych innowacyjnych firm zaprezentowało swoje rozwiązanie do ratowania ptaków na farmach wiatrowych. Duże zainteresowanie i deklaracje od przyszłych klientów potwierdzają kierunek rozwoju technologii Bioseco. ",
        type: "text-type",
        date: "02.03.2015"
      },
      {
        img: "/static/img/media/counter.jpg",
        title: "Został zrealizowany projekt detekcji i zliczania samochodów w ruchu miejskim ",
        text: "Bioseco wykonało unikatowy system monitoringu, który polega na zliczaniu samochodów na skrzyżowaniach. Klient będzie używał systemu do monitorowania skuteczności nośników reklam outdoor. \n" +
          "Więcej w <a href='https://www.portalspozywczy.pl/handel/wiadomosci/nowy-system-do-mierzenia-skutecznosci-reklamy-zewnetrznej,110593.html?fbclid=IwAR0H1iwXtYwS0Yo8uIi9gobgpKVEs6R4d5Qvn-GUzgJ09hA8xAKRScHIK2Y'>artykule</a>",
        type: "text-type",
        date: "02.02.2015"
      },
      {
        img: "/static/img/media/sztormy.jpg",
        title: "Nasza firma zdobyła prestiżową nagrodę Pomorskie Sztormy",
        text: "Bioseco zwyciężyło w kategorii Młoda Firma 2014 Roku w konkursie organizowanym przez Marszałka Województwa i Gazetę Wyborczą. Wysoką rangę imprezy podkreśliła obecność prezydentów Gdyni, Gdańska oraz Sopotu, jak również oczywiście Marszałka Województwa. Gala miała miejsce w Teatrze Szekspirowskim w Gdańsku. ",
        type: "text-type",
        date: "20.12.2014"
      },
      {
        img: "/static/img/media/swiss.jpg",
        title: "Prezentacja rozwiązania Bioseco w Szwajcarii",
        text: "Na Swiss-Polish Roundtable on Innovation przedstawiciele Bioseco zaprezentowali koncepcję urządzenia i możliwości rozwiązania monitorującego i ratującego ptaki. Temat spotkał się dużym zainteresowaniem. ",
        type: "text-type",
        date: "28.10.2014"
      },
      {
        img: "/static/img/media/lider-ppnt.jpg",
        title: "Lider PPNT Gdynia w kategorii „Produkt, usługa, marka”",
        text: "Bioseco otrzymało nagrodę Lider PPNT Gdynia jako najbardziej wyróżniająca się marka i firma w 2014 r. W plebiscycie brała udział cała społeczność PPNT Gdynia licząca niemal trzysta innowacyjnych firm.",
        type: "text-type",
        date: "20.12.2014"
      },

    ]
  }
}



// WEBPACK FOOTER //
// ./src/lang/pl.js